<template>
  <div class="details">
    <div class="notice">
      <van-image
        class="notice-icon"
        :src="require('../../../assets/cs-pic.png')"
      />
      <div class="notice-text">{{ notice }}</div>
    </div>
    <div class="list">
      <div class="list-title">{{ goodsName }}</div>
      <div class="list-main">
        <div class="list-main-imgwrap">
          <van-image class="list-main-imgwrap-img" fit="cover" :src="img" />
          <div class="list-main-imgwrap-tab" v-if="iscoupons == 1">券</div>
        </div>
        <div class="list-main-info">
          <div class="list-main-info-price">
            合同金额
            {{ price === null ? '' : '￥'
            }}<span>{{ price === null ? '面议' : price }}</span>
          </div>
          <div class="list-main-info-type">机构名称：{{ goodsOrg }}</div>
          <div class="list-main-info-type">类型：{{ type }}</div>
        </div>
      </div>
      <div class="list-bottom">
        <div class="list-bottom-status">
          <van-image
            class="list-bottom-status-icon"
            :src="status == 3 ? img3 : status == 4 ? img2 : img1"
          />
          <div
            class="list-bottom-status-text"
            :style="{
              color:
                status == 3 ? '#39CD36' : status == 4 ? '#666666' : '#0080FF'
            }"
          >
            {{ statusText }}
          </div>
          <div
            v-if="status === 4 && couponsPrice"
            style="background: rgba(57, 205, 54, 0.1);border-radius: 4px;font-size:13px;padding:8px;margin-left:20px"
          >
            <span style="color:#39CD36">退款成功</span> 已退回服务券￥{{
              couponsPrice
            }}元
          </div>
        </div>
      </div>
    </div>
    <div class="info-text">
      <div class="info-text-tit">合同服务时间</div>
      <div class="info-text-tab">
        {{ contractServiceStartStr }}~{{ contractServiceEndStr }}
      </div>
    </div>
    <div class="price" v-if="iscoupons == 1 && status > 0 && status != 4">
      <div class="price-text" @click="couponsTap">
        <div class="price-text-tit">服务券</div>
        <div class="price-text-tab">
          {{ coupons }}
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="price-text" v-if="couponsId">
        <div class="price-text-tit">服务券抵扣</div>
        <div class="price-text-tab font-big">￥{{ couponsPrice }}</div>
      </div>
      <div class="price-text">
        <div class="price-text-tit">实付款金额</div>
        <div class="price-text-tab font-big">￥{{ total }}</div>
      </div>
    </div>
    <div class="info">
      <div class="info-title">买家信息</div>
      <div class="info-text">
        <div class="info-text-tit">联系人</div>
        <div class="info-text-tab">{{ concat }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">联系电话</div>
        <div class="info-text-tab">{{ concatTel }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">地址</div>
        <div class="info-text-tab">{{ address }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">订单编号</div>
        <div class="info-text-tab">{{ sn }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">订单创建时间</div>
        <div class="info-text-tab">{{ creatTime }}</div>
      </div>
      <div class="info-text">
        <div class="info-text-tit">备注信息</div>
        <div class="info-text-tab">{{ content || '无' }}</div>
      </div>
    </div>
    <div class="infoQuestion">
      <div>资料提交</div>
      <div @click="onGoQuestionDetail()">
        <img src="@/assets/images/information.png" alt="" />
        提交信息
      </div>
      <div @click="onOrderCancel()" v-if="status === 0 || status === 1">
        <img src="@/assets/images/orderCancel.png" alt="" />
        取消订单
      </div>
    </div>
    <div class="sure" v-if="status != 0 && status != 4">
      <div class="sure-price font-big1" v-if="status == 1">
        合计：￥<span>{{ total }}</span>
        <div style="font-size: 14px; color: red" v-if="couponsPrice > 0">
          优惠￥{{ couponsPrice }}
        </div>
      </div>
      <van-button class="sure-btn" type="info" @click="btnTap">{{
        btnText
      }}</van-button>
    </div>
    <!-- 评价弹窗 -->
    <van-popup v-model="startShow" position="bottom">
      <div class="pop">
        <div class="pop-title">
          <div class="pop-title-text">订单评价</div>
          <van-icon name="cross" @click="startShow = false" />
        </div>
        <div class="pop-main">
          <van-radio-group
            v-model="rateValue"
            :disabled="status !== 2"
            direction="horizontal"
            style="height: 80px; justify-content: center"
            @change="rateChange"
          >
            <van-radio :name="3" style="margin-right: 50px">
              <template #icon="props">
                <img
                  class="img-icon"
                  style="width: 50px"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
            <van-radio :name="1" style="margin-right: 0">
              <template #icon="props">
                <img
                  class="img-icon"
                  style="width: 50px"
                  :src="props.checked ? activeIcon1 : inactiveIcon1"
                />
              </template>
            </van-radio>
          </van-radio-group>
          <!-- <van-rate
            class="pop-main-start"
            v-model="rateValue"
            :size="25"
            count="3"
            color="#FFD21E"
            void-icon="star"
            void-color="#eee"
            :readonly="status == 3 ? true : false"
            @change="rateChange"
          /> -->
          <div class="pop-main-text">{{ rateText }}</div>
          <van-field
            class="pop-main-rateMessage"
            v-model="rateMessage"
            rows="5"
            autosize
            type="textarea"
            :placeholder="status == 3 ? '无' : '请输入评价详情'"
            maxlength="200"
            show-word-limit
            :readonly="status == 3 ? true : false"
          />
          <van-button
            v-if="status == 2"
            class="pop-main-btn"
            type="info"
            @click="rateTap"
            >立即提交</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import { orderDetail, confirmOrder, evaluateOrder } from '@api/market/index'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { Toast } from 'vant'
export default {
  data() {
    return {
      img1: require('@/assets/sc-pic1.png'),
      img2: require('@/assets/失效状态@4x.png'),
      img3: require('@/assets/完成状态@4x.png'),
      id: '', // 订单id
      notice: '', // 顶部提示
      status: '', // 状态值
      statusText: '', // 状态
      goodsName: '', // 商品名
      img: '',
      iscoupons: '',
      priceType: '',
      price: 0, // 金额
      goodsOrg: '',
      concat: '',
      concatTel: '',
      type: '', // 类型
      address: '', // 地址
      sn: '', // 订单号
      creatTime: '', // 订单创建时间
      content: '', // 备注
      coupons: '请选择服务券', // 服务券金额
      couponsPrice: '',
      couponsId: '',
      total: 0, // 实际付款金额
      btnText: '', // 按钮文字
      startShow: false, // 评价弹窗
      rateValue: 3, // 评分
      rateText: '好评',
      rateMessage: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      contractServiceEndStr: '', // 服务合同开始时间
      contractServiceStartStr: '', // 服务合同结束时间
      activeIcon: require('@/assets/好评-点击状态@4x.png'),
      inactiveIcon: require('@/assets/好评-默认状态@4x.png'),
      activeIcon1: require('@/assets/差评-点击状态@4x.png'),
      inactiveIcon1: require('@/assets/差评-默认状态@4x.png')
    }
  },
  mounted() {
    this.getOrderDetail()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    getOrderDetail() {
      const params = {
        id: this.$route.query.id
      }

      orderDetail(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          let statusText = ''
          let btnText = ''
          let notice = ''
          const statusOrder =
            data.failureStatus === 2
              ? '企业 (' + data.staffName + ') ' + '取消订单，订单已失效'
              : '超过90天未确认，订单已失效'
          switch (data.orderStatus) {
            case 0:
              statusText = '待机构确认'
              notice = '请线下和机构联系，并等待机构确认金额'
              break
            case 1:
              statusText = '待企业确认'
              btnText = '确认订单'
              notice = '请确认是否可以用服务券，且金额是否正确!'
              break
            case 2:
              statusText = '待评价'
              btnText = '评价'
              notice = '请对该商品/服务进行评价！'
              break
            case 3:
              statusText = '已完成'
              btnText = '查看评价'
              notice = '感谢您的评价！'
              break
            case 4:
              statusText = '已失效'
              notice = statusOrder
              break
          }
          let rateText = '好评'
          switch (data.evaluateLevel) {
            case 1:
              rateText = '差评'
              break
            case 3:
              rateText = '好评'
              break
          }
          this.id = data.id
          this.notice = data.invalidRemark || notice
          this.status = data.orderStatus
          this.statusText = statusText
          this.btnText = btnText
          this.goodsName = data.goodsName
          this.img = data.goodsUrl
          this.iscoupons = data.useCoupon
          this.goodsOrg = data.goodsOrg
          this.type = data.goodsType
          this.price = data.price
          this.concat = data.concat
          this.concatTel = data.concatTel
          this.address = data.address
          this.sn = data.orderNo
          this.creatTime = data.createTime
          this.content = data.remark
          this.contractServiceStartStr = data.contractServiceStartStr
          this.contractServiceEndStr = data.contractServiceEndStr
          // 待评价，已评价状态下有服务券选项
          this.couponsId = data.couponId
          if (data.orderStatus == 2 || data.orderStatus == 3) {
            this.coupons = data.couponName || '无'
          } else {
            this.coupons = data.couponName || '请选择服务券'
          }
          this.couponsPrice = data.deductionPrice || 0
          this.total = data.realPay

          this.rateValue = data.evaluateLevel || 3
          this.rateText = rateText
          this.rateMessage = data.evaluateFeedback || ''
          if (getLocalStorage('coupons')) {
            let coupons = JSON.parse(localStorage.getItem('coupons'))
            this.couponsId = coupons.entCouponId
            this.coupons = coupons.couponName
            this.couponsPrice = coupons.deductionPrice.toFixed(2)
            this.total = (this.price - this.couponsPrice).toFixed(2)
          }
        } else {
          Toast(msg)
        }
      })
    },
    couponsTap() {
      if (this.status == 1) {
        this.$router.push({
          path: '/market/coupons',
          query: {
            goodsType: this.type,
            price: this.price,
            couponsId: this.couponsId
          }
        })
      }
    },
    btnTap() {
      if (this.status == 1) {
        // 企业确认
        Dialog.confirm({
          title: '提醒',
          message: '是否确认提交订单？'
        }).then(() => {
          const params = {
            id: this.id,
            entCouponId: this.couponsId,
            deductionPrice: this.couponsPrice,
            realPay: this.total
          }
          confirmOrder(params).then(res => {
            const { code, data, msg } = res.data
            if (code == '0000') {
              this.buriedPoint()
              Toast('订单提交成功')
              this.getOrderDetail()
            } else {
              Toast(msg)
            }
          })
        })
      } else if (this.status == 2 || this.status == 3) {
        // 评价 || 查看评价
        this.startShow = true
      }
    },
    // 评分
    rateChange(e) {
      switch (e) {
        case 1:
          this.rateText = '差评'
          break
        case 3:
          this.rateText = '好评'
          break
      }
    },
    // 提交评价
    rateTap() {
      if (this.rateValue == 1 && !this.rateMessage) {
        Toast('请填写差评原因')
        return
      }
      const params = {
        id: this.$route.query.id,
        evaluateLevel: this.rateValue,
        evaluateFeedback: this.rateMessage
      }
      evaluateOrder(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.startShow = false
          Toast('评价成功')
          this.getOrderDetail()
        } else {
          Toast(msg)
        }
      })
    },
    // 查看资料
    onGoQuestionDetail() {
      this.$router.push({
        path: '/market/questionDetail?id=' + this.id
      })
    },
    // 取消订单
    onOrderCancel() {
      this.$router.push({
        path: '/market/orderCancel?id=' + this.id
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.details {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 80px;
  box-sizing: border-box;
}
.font-big {
  font-size: 16px !important;
  font-weight: bold;
  color: red !important;
}
.font-big1 {
  font-size: 15px !important;
  // font-weight: bold;
  span {
    font-size: 28px !important;
  }
}
.notice {
  padding: 15px;
  background: #0080ff;
  display: flex;
  align-items: center;
  &-icon {
    width: 16px;
    height: 16px;
  }
  &-text {
    flex: 1;
    font-size: 14px;
    color: #fff;
    padding-left: 8px;
  }
}
.list {
  background: #fff;
  border-radius: 4px;
  &-title {
    font-size: 16px;
    padding: 10px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #eee;
  }
  &-main {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    &-imgwrap {
      position: relative;
      &-img {
        width: 90px;
        height: 80px;
      }
      &-tab {
        padding: 6px;
        background: #ff5c2c;
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-right-radius: 10px;
      }
    }
    &-info {
      flex: 1;
      padding-left: 10px;
      margin-top: -6px;
      &-price {
        font-size: 14px;
        color: #999;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
      }
      &-type {
        font-size: 14px;
        color: #999;
        margin-top: 8px;
      }
    }
  }
  &-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 0;
    &-status {
      height: 36px;
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 15px;
      // background: #fff9f5;
      border-radius: 6px;
      &-icon {
        width: 16px;
        // height: 16px;
      }
      &-text {
        font-size: 14px;
        color: #ff6600;
        padding-left: 10px;
      }
    }
  }
}
.price {
  margin-top: 15px;
  &-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #fff;
    border-bottom: 1px solid #eee;
    &:last-child {
      border: none;
    }
    &-tit {
      font-size: 15px;
      white-space: nowrap;
    }
    &-tab {
      padding-left: 10px;
      font-size: 14px;
      color: #999;
      .van-icon {
        vertical-align: middle;
        margin-top: -2px;
      }
    }
  }
}
.info {
  &-title {
    padding: 15px;
    font-size: 15px;
    color: #999;
  }
  &-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #fff;
    border-bottom: 1px solid #eee;
    &:last-child {
      border: none;
    }
    &-tit {
      font-size: 15px;
      white-space: nowrap;
    }
    &-tab {
      padding-left: 10px;
      font-size: 14px;
      color: #999;
    }
  }
}
.infoQuestion {
  margin-top: 20px;
  background: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-size: 20px;
  padding: 10px 15px;
  & > div {
    line-height: 40px;
  }
  & > div:nth-child(2),
  & > div:nth-child(3) {
    display: inline-block;
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
    img {
      vertical-align: middle;
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
  & > div:nth-child(3) {
    margin-left: 34px;
  }
}
.sure {
  padding: 10px 15px;
  background: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  &-price {
    min-width: 56%;
    font-size: 14px;
    span {
      font-size: 20px;
      color: #ff5c2c;
    }
  }
  &-btn {
    flex: 1;
    border-radius: 6px;
  }
}
.pop {
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
    &-text {
      font-size: 15px;
    }
    .van-icon {
      font-size: 16px;
    }
  }
  &-main {
    text-align: center;
    padding: 0 15px 15px;
    &-start {
      /deep/.van-rate__icon {
        margin: 0 6px;
      }
    }
    &-text {
      font-size: 14px;
      padding: 6px 0 20px;
      color: #666;
    }
    &-rateMessage {
      border: 1px solid #eee;
      border-radius: 4px;
    }
    &-btn {
      width: 100%;
      margin-top: 30px;
    }
  }
}
</style>
